import dynamic from 'next/dynamic';

import { Link } from '#components/Link/Link';
import type { SectionTileRegional4Simple } from '#domains/resolver/board-section-data';
import { IconSystem } from '#icons/IconSystem';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_ONE_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionItemBR24In100Seconds } from '../Items/BoardSectionItemBR24In100Seconds';
import { BoardSectionItemBR24Rundschau } from '../Items/BoardSectionItemsBR24Rundschau';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

import styles from './BoardSectionTileRegional4.module.scss';

const BoardSectionItemMap = dynamic(() =>
	import('#components/Board/Section/Items/BoardSectionItemMap').then(({ BoardSectionItemMap }) => BoardSectionItemMap)
);

type Props = {
	section: SectionTileRegional4Simple;
};

export function BoardSectionTileRegional4({ section }: Props) {
	const [[topLeft, topCenter], [bottomLeft, bottomCenter]] = section.items;

	if (topLeft.type === 'empty' || topCenter.type === 'empty' || bottomLeft.type === 'empty' || bottomCenter.type === 'empty') {
		return null;
	}

	return (
		<BoardSectionTileSection>
			<BoardSectionTileRow>
				<Tracktor trackingData={{ data: { inSectionPlacement: 0 } }}>
					<BoardSectionItem teaser={topLeft} sizes={IMAGE_SIZE_ONE_THIRD} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 1 } }}>
					<BoardSectionItem teaser={topCenter} sizes={IMAGE_SIZE_ONE_THIRD} />
				</Tracktor>
				<div className={styles.videoSection} data-theme-area="dark">
					<div className={styles.videoSectionTitle}>
						<h3 className="heading4">Nachrichten: live und im Überblick</h3>
					</div>
					{!section.hideRundschau ? (
						<Tracktor trackingData={{ data: { inSectionPlacement: 2 } }}>
							<BoardSectionItemBR24Rundschau />
						</Tracktor>
					) : null}
					<Link
						className={`${styles.bannerSection} outline-inside`}
						target="_blank"
						href="https://www.ardmediathek.de/sendung/br24/Y3JpZDovL2JyLmRlL2Jyb2FkY2FzdFNlcmllcy9icm9hZGNhc3RTZXJpZXM6L2JyZGUvZmVybnNlaGVuL2JheWVyaXNjaGVzLWZlcm5zZWhlbi9zZW5kdW5nZW4vcnVuZHNjaGF1"
					>
						<span className={`heading4 ${styles.bannerMediathek}`}>Alle BR24 Nachrichtensendungen in der ARD Mediathek</span>
						<IconSystem className={styles.externalLink} icon="external-link" variant="outline" title="Externer Link" />
					</Link>
					<Tracktor trackingData={{ data: { inSectionPlacement: 3 } }}>
						<BoardSectionItemBR24In100Seconds newsVideo={section.br24100Sec} />
					</Tracktor>
				</div>
			</BoardSectionTileRow>

			<BoardSectionTileRow>
				<Tracktor trackingData={{ data: { inSectionPlacement: 4 } }}>
					<BoardSectionItem teaser={bottomLeft} sizes={IMAGE_SIZE_ONE_THIRD} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 5 } }}>
					<BoardSectionItem teaser={bottomCenter} sizes={IMAGE_SIZE_ONE_THIRD} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 6 } }}>
					<BoardSectionItemMap selectedDistrict={section.selectedDistrict} />
				</Tracktor>
			</BoardSectionTileRow>
		</BoardSectionTileSection>
	);
}
